/* eslint-disable */

import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'

import {
  configure,
  refinementList,
  infiniteHits,
  menuSelect,
  sortBy,
} from 'instantsearch.js/es/widgets'

import {
  connectInfiniteHits,
  connectRefinementList,
  connectMenu,
} from 'instantsearch.js/es/connectors'

import translate from '../translations'

/* global config */

// import getQueryVariable from '../utils/getQueryVariable'
import moment from 'moment'
import slugify from '../utils/slugify'
import stringToHTML from '../utils/stringToHTML'
import truncate from '../utils/truncate'

import downloadTpl from './cards-templates/download'
import eventTpl from './cards-templates/event'
import newsTpl from './cards-templates/news'
import pageTpl from './cards-templates/page'
import pressReleaseTpl from './cards-templates/press-release'
import pressSummaryTpl from './cards-templates/press-summary'
import reportTpl from './cards-templates/report'
import socialNetworkTpl from './cards-templates/social-network'

export default {
  name: 'page-multicards-filters',

  isMobile: false,

  forcedType: '',

  hitsPerPage: 9999999,
  hitsDisplayed: 0,
  firstLoading: true,

  componentDidMount() {
    this.locale = document.querySelector('html').getAttribute('lang')
    moment.locale(this.locale)

    this.blockNews = document.querySelector('.results[data-type="news"]')
    this.blockPages = document.querySelector('.results[data-type="page"]')
    this.blockDocument = document.querySelector(
      '.results[data-type="document"]'
    )
    this.blockReport = document.querySelector('.results[data-type="report"]')
    this.blockPressSummary = document.querySelector(
      '.results[data-type="press-summary"]'
    )
    this.blockPressRelease = document.querySelector(
      '.results[data-type="press-release"]'
    )
    this.blockEvents = document.querySelector('.results[data-type="event"]')
    this.blockSocialNetworks = document.querySelector(
      '.results[data-type="social-network"]'
    )

    this.type = this.props.type === 'all' ? '' : this.props.type
    this.preDefinedTags = this.props.tags ? this.props.tags.split(',') : []
    this.facetFilters = []
    // to switch from AND to OR : https://www.algolia.com/doc/api-reference/api-parameters/facetFilters/
    this.facetFilters[0] = []
    //
    this.sourceType = this.type

    const searchIndex = `${config.algolia.env}_pages`
    // const searchIndex = `local_frontUsers`
    let searchFilter = 'visible:true'
    searchFilter += ` AND locale: "${this.locale}"`
    searchFilter += ` AND NOT objectID:${this.props.id}`

    this.search = instantsearch({
      indexName: searchIndex,
      searchClient: algoliasearch(
        config.algolia.applicationID,
        config.algolia.apiKey
      ),
      numberLocale: this.locale,
      /* searchFunction(helper) { // SI FONCTION DEFINIE PLUS AUCUN RESULTAT (FACETS / HITS)
        const page = helper.getPage(); // Retrieve the current page
        console.log('helper', helper)
        if (helper.state.query) {
          helper.search();
        }
      }, */
      /*searchParameters: {
        hitsPerPage: this.hitsPerPage,
        distinct: true,
        filters: searchFilter,
      },*/
      routing: true,
    })

    if (this.preDefinedTags.length <= 0) {
      if (this.type !== 'job-card') {
        this.manageSelect()
        this.manageMultipleFacets()
      }
    } else {
      // if (this.props.type === 'all') {
      this.el.classList.remove('flex')
      this.el.classList.add('hidden')
    }

    this.manageResults()

    if (this.preDefinedTags.length >= 0) {
      /* for (const tag of this.preDefinedTags) {
        this.facetFilters[0].push(`tags.name:${tag}`)
      }*/
      // REFACT FOR IE 11
      this.preDefinedTags.forEach(tag => {
        this.facetFilters[0].push(`tags.name:${tag}`)
      })
    }

    this.search.addWidgets([
      configure({
        hitsPerPage: this.hitsPerPage,
        // distinct: true,
        filters: searchFilter,
        facetFilters: this.facetFilters,
      }),
      this.customInfiniteHitsWidget,
    ])

    this.search.on('render', e => {
      // Do something on render
      // hide / display bt reset if a filter is selected or not
      // document.querySelector('.filtered-grid__filters__list__item--selected') ? this.btResetFilters.classList.remove('invisible') : this.btResetFilters.classList.add('invisible')
    })

    this.search.start()

    /*for (let btLoadMore of document.querySelectorAll('[js-load-more]')) {
      btLoadMore.addEventListener('click', e => {
        e.preventDefault()
        this.forcedType = e.target.parentNode.getAttribute('data-type')
        this.search.helper.search()
      })
    }*/
    Array.prototype.forEach.call(
      document.querySelectorAll('[js-load-more]'),
      btLoadMore => {
        btLoadMore.addEventListener('click', e => {
          e.preventDefault()
          this.forcedType = e.target.parentNode.getAttribute('data-type')
          this.search.helper.search()
        })
      }
    )
  },

  manageResults() {
    // Create the render function
    const renderInfiniteHits = (renderOptions, isFirstRender) => {
      const { hits, showMore, isLastPage, widgetParams } = renderOptions
      const parentContainer = widgetParams.container // .parentNode

      // first render, construct empty ul && button more
      if (isFirstRender) {
        // const button = document.createElement('button')
        // button.classList.add('button')
        // button.classList.add('button--black', 'my-5')
        // button.textContent = 'Afficher plus'
        // button.addEventListener('click', () => {
        //   showMore()
        // })
        // const wrapper = document.createElement('div')
        // wrapper.classList.add('wrapper', 'w-full', 'text-left')
        // widgetParams.container.appendChild(wrapper)
        // parentContainer.appendChild(button)
        // return
      }
      const arrayNews = []
      const arrayPages = []
      const arrayReports = []
      const arrayDocument = []
      const arrayPressRelease = []
      const arrayPressSummary = []
      const arrayEvents = []
      const arraySocialNetwork = []

      const mediaPath = `//${config.cloudinary.host}/${
        config.cloudinary.options.cloud_name
      }/`

      let imgW = 650
      let imgH = 400
      if (this.type === 'document') {
        imgW = 280
        imgH = 363
      }

      //for (let hit of hits) {
      Array.prototype.forEach.call(hits, hit => {
        let cardType =
          hit._highlightResult && hit._highlightResult.type
            ? hit._highlightResult.type.value
            : ''

        if (cardType) {
          switch (cardType) {
            case 'news':
              if (this.isMediaRoom) {
                const websiteValue =
                  hit.contentProperties && hit.contentProperties.website
                const isGifas = Array.isArray(websiteValue)
                  ? websiteValue.indexOf('gifas') !== -1
                  : websiteValue === 'gifas'
                if (isGifas) arrayNews.push(hit)
              } else {
                arrayNews.push(hit)
              }
              break
            case 'document':
              arrayDocument.push(hit)
              break
            case 'press-release':
              arrayPressRelease.push(hit)
              break
            case 'press-summary':
              // condition pour ne pas les afficher sur la mediaroom
              if (this.preDefinedTags.length > 0) arrayPressSummary.push(hit)
              break
            case 'social-network':
              arraySocialNetwork.push(hit)
              break
            case 'report':
              arrayReports.push(hit)
              break
            default:
            case 'list':
            case 'page':
              // condition pour ne pas les afficher sur la mediaroom && exclure la page courante
              if (
                this.preDefinedTags.length > 0 &&
                window.location.pathname !== `/${hit.path}`
              )
                arrayPages.push(hit)
              break
          }
        }
      })

      if (arrayNews.length > 0) {
        for (let i = 0; i < arrayNews.length; i++) {
          const hit = arrayNews[i]
          if (hit.contentProperties.event) {
            arrayEvents.push(hit)
            arrayNews.splice(i, 1)
          }
        }
      }

      if (arrayDocument.length > 0) {
        for (let i = 0; i < arrayDocument.length; i++) {
          const hit = arrayDocument[i]
          if (hit.contentProperties.type === 'report') {
            arrayReports.push(hit)
            arrayDocument.splice(i, 1)
          }
        }
      }

      /*console.log(hits)
      console.log('news', arrayNews.length)
      console.log('page', arrayPages.length)
      console.log('report', arrayReports.length)
      console.log('dov', arrayDocument.length)
      console.log('press Release', arrayPressRelease.length)
      console.log('press SUM', arrayPressSummary.length)
      console.log('events', arrayEvents.length)
      console.log('SN', arraySocialNetwork.length)*/
      if (this.forcedType !== '') {
        let block
        let array = []
        switch (this.forcedType) {
          case 'news':
            block = this.blockNews
            array = arrayNews
            break
          case 'page':
            block = this.blockPages
            array = arrayPages
            break
          case 'document':
            block = this.blockDocument
            array = arrayDocument
            break
          case 'report':
            block = this.blockReport
            array = arrayReports
            break
          case 'press-release':
            block = this.blockPressRelease
            array = arrayPressRelease
            break
          case 'press-summary':
            block = this.blockPressSummary
            array = arrayPressSummary
            break
          case 'event':
            block = this.blockEvents
            array = arrayEvents
            break
          case 'social-network':
            block = this.blockSocialNetworks
            array = arraySocialNetwork
            break
        }

        const total = array.length
        const hitsDisplayed = block.querySelectorAll('.results__wrapper li')
          .length
        const limit = parseInt(block.getAttribute('data-limit'))
        const deletedArray = array.splice(hitsDisplayed, limit)

        this.setUpBlock(block, deletedArray, this.forcedType)

        if (block.querySelectorAll('li').length >= total) {
          block.querySelector('[js-load-more]').classList.add('hidden')
        }
      } else {
        if (arrayNews.length > 0) {
          this.setUpBlock(this.blockNews, arrayNews, 'news')
        } else {
          this.blockNews.classList.add('hidden')
        }

        if (arrayPages.length > 0) {
          this.setUpBlock(this.blockPages, arrayPages, 'page')
        } else {
          this.blockPages.classList.add('hidden')
        }

        if (arrayDocument.length > 0) {
          this.setUpBlock(this.blockDocument, arrayDocument, 'document')
        } else {
          this.blockDocument.classList.add('hidden')
        }

        if (arrayReports.length > 0) {
          this.setUpBlock(this.blockReport, arrayReports, 'report')
        } else {
          this.blockReport.classList.add('hidden')
        }

        if (arrayPressRelease.length > 0) {
          this.setUpBlock(
            this.blockPressRelease,
            arrayPressRelease,
            'press-release'
          )
        } else {
          this.blockPressRelease.classList.add('hidden')
        }

        if (arrayPressSummary.length > 0) {
          this.setUpBlock(
            this.blockPressSummary,
            arrayPressSummary,
            'press-summary'
          )
        } else {
          this.blockPressSummary.classList.add('hidden')
        }

        if (arrayEvents.length > 0) {
          this.setUpBlock(this.blockEvents, arrayEvents, 'event')
        } else {
          this.blockEvents.classList.add('hidden')
        }

        if (arraySocialNetwork.length > 0) {
          this.setUpBlock(
            this.blockSocialNetworks,
            arraySocialNetwork,
            'social-network'
          )
        } else {
          this.blockSocialNetworks.classList.add('hidden')
        }
      }

      this.triggerResizeForHeaderCalculation()
    }

    // Create the custom widget
    const customInfiniteHits = connectInfiniteHits(renderInfiniteHits)
    this.customInfiniteHitsWidget = customInfiniteHits({
      container: this.el,
    })
    // Instantiate the custom widget
    /*this.search.addWidget(
      this.customInfiniteHitsWidget
    )*/
  },

  manageMultipleFacets() {
    // 1. Create a render function
    const renderRefinementList = (renderOptions, isFirstRender) => {
      const {
        items,
        isFromSearch,
        refine,
        createURL,
        isShowingMore,
        canToggleShowMore,
        searchForItems,
        toggleShowMore,
        widgetParams,
      } = renderOptions

      const button = this.el.querySelector('.bt')

      if (isFirstRender) {
        button.addEventListener('click', () => {
          toggleShowMore()
        })
      }

      if (isShowingMore) {
        button.classList.add('tag--less')
        button.innerText = translate('LESS_TAGS')
      } else {
        button.classList.remove('tag--less')
        button.innerText = translate('MORE_TAGS')
      }

      widgetParams.container.innerHTML = items
        .map(
          item => `
            <li class="facets__item">
              <a class="tag ${
                item.isRefined ? 'tag--selected' : ''
              } tag--${slugify(item.value)}"
                href="${createURL(item.value)}"
                data-value="${item.value}"
                data-text="${item.value}"
              >
                ${item.label}
                <div class="bg-color color-${slugify(item.value)}"></div>
              </a>
            </li>
          `
        )
        .join('')
      ;[...widgetParams.container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault()
          this.resetDisplay()
          refine(event.currentTarget.dataset.value)
          /* if (this.isMobile) {
            setTimeout(_ => {
              this.closeFilterSelect()
            }, 400)
          } */
        })
      })
    }

    // 2. Create the custom widget
    const customRefinementList = connectRefinementList(renderRefinementList)
    // 3. Instantiate
    this.search.addWidgets([
      customRefinementList({
        container: this.el.querySelector('.facets-wrapper'),
        attribute: 'tags.name',
        limit: 4,
        showMore: true,
        showMoreLimit: 200,
        sortBy: ['count:desc', 'name:asc'],
        operator: 'or',
      }),
    ])
  },

  manageSelect() {
    // Create the render function
    const renderMenuSelect = (renderOptions, isFirstRender) => {
      const { items, canRefine, refine, widgetParams } = renderOptions

      // if (isFirstRender) {
      if (this.el.querySelectorAll('select option').length <= 1) {
        const select = this.el.querySelector('select')
        if (isFirstRender) {
          select.addEventListener('change', event => {
            setTimeout(() => {
              this.resetDisplay()
              refine(select.value)
            }, 150)
          })
        }

        //const select = this.el.querySelector('select') // widgetParams.container.querySelector('select');

        select.disabled = !canRefine

        // select.empty();

        select.innerHTML = `
          <option value="">${translate('YEAR')}</option>
          ${items
            .map(
              item =>
                `<option
                  value="${item.value}"
                  ${item.isRefined ? 'selected' : ''}
                >
                  ${item.label}
                </option>`
            )
            .join('')}
        `
      }
    }

    // Create the custom widget
    const customMenuSelect = connectMenu(renderMenuSelect)

    // Instantiate the custom widget
    this.search.addWidgets([
      customMenuSelect({
        container: document.querySelector('.custom-select'),
        attribute: 'year',
      }),
    ])
  },

  setUpBlock(block, cardsArray, type) {
    let cards = cardsArray

    if (this.forcedType === '')
      block.querySelector('.count').innerText = `(${cards.length})`

    const limit = parseInt(block.getAttribute('data-limit'))
    const btMore = block.querySelector('.bt.tag--more')

    if (cards.length > limit) {
      cards = cardsArray.slice(0, limit)
      btMore.classList.remove('hidden')
    } else if (this.forcedType === '') {
      btMore.classList.add('hidden')
    }

    const wrapper = block.querySelector('.results__wrapper')
    //for (let hit of cards) {
    Array.prototype.forEach.call(cards, hit => {
      const data = {}

      const mediaPath = `//${config.cloudinary.host}/${
        config.cloudinary.options.cloud_name
      }/`

      let imgW = 650
      let imgH = 400
      if (type === 'report') {
        imgW = 465
        imgH = 603
      } else if (type === 'document') {
        imgW = 280
        imgH = 363
      }

      data.imgSrc =
        hit.contentProperties && hit.contentProperties.picture
          ? `${mediaPath}/c_fill,f_auto,q_auto,g_north,w_${imgW},h_${imgH}/${
              hit.contentProperties.picture.singleMedia.publicId
            }.${hit.contentProperties.picture.singleMedia.originalFormat}`
          : '/assets/front/card-edito-home.jpg'

      data.fileURL =
        hit.contentProperties && hit.contentProperties.pdf
          ? hit.contentProperties.pdf.pdfLink
            ? `${mediaPath}image/upload/${hit.contentProperties.pdf.pdfLink}`
            : `${mediaPath}image/upload/${
                hit.contentProperties.pdf.singleMedia.publicId
              }.${hit.contentProperties.pdf.singleMedia.originalFormat}`
          : ''

      data.date = ''
      if (hit.contentProperties && hit.contentProperties.date) {
        const formattedDate = moment(hit.contentProperties.date.date).format(
          'D MMM YYYY'
        )
        data.date = `<div class="date mb-2">${formattedDate}</div>`
      }

      data.title = hit.title
      data.desc =
        hit.customProperties && hit.customProperties.excerpt
          ? hit.customProperties.excerpt
          : hit.description
          ? hit.description
          : hit.belonging
          ? hit.belonging
          : ''
      const htmlDesc = stringToHTML(data.desc)
      data.desc = htmlDesc ? htmlDesc.innerText : ''

      data.tag = ''
      if (hit.tags) {
        const t = hit.tags.length > 0 ? hit.tags[0] : { name: '' }
        if (t.name != '') {
          const tagLink = `${window.location.href.split('?')[0]}?${
            config.algolia.env
          }_pages%5BrefinementList%5D%5Btags.name%5D%5B0%5D=${slugify(t.name)}`
          data.tag += `<a href="${tagLink}" class="tag tag--${slugify(
            t.name
          )} tag--selected" data-text="${t.name}">
                        <div class="bg-color color-${slugify(t.name)}"></div>
                 ${t.name}
                </a>`
        }
      }
      data.url =
        hit.contentProperties && hit.contentProperties.url
          ? hit.contentProperties.url
          : hit.path

      data.socialnetwork = {}
      data.socialnetwork.type =
        hit.contentProperties && hit.contentProperties.type
          ? hit.contentProperties.type
          : ''
      data.socialnetwork.name =
        hit.contentProperties && hit.contentProperties.name
          ? hit.contentProperties.name
          : ''
      data.socialnetwork.content =
        hit.contentProperties && hit.contentProperties.content
          ? hit.contentProperties.content
          : ''
      data.socialnetwork.url =
        hit._highlightResult &&
        hit._highlightResult.contentProperties &&
        hit._highlightResult.contentProperties.url
          ? hit._highlightResult.contentProperties.url.value
          : ''

      let card = document.createElement('li')
      card.classList.add('card')

      let fragment = document.createDocumentFragment()

      if (type === 'news') {
        card.classList.add('card--actu', 'min-h-1/2')
        card.innerHTML = newsTpl(data)
      } else if (type === 'document') {
        card.classList.add('card--download')
        card.innerHTML = downloadTpl(data)
      } else if (type === 'report') {
        card.classList.add('card--report')
        card.innerHTML = reportTpl(data)
      } else if (type === 'event') {
        card.classList.add('card--event', 'min-h-1/2')
        card.innerHTML = eventTpl(data)
      } else if (type === 'page') {
        card.classList.add('card--page')
        card.innerHTML = pageTpl(data)
      } else if (type === 'press-release') {
        card.classList.add('card--news', 'min-h-1/2')
        card.innerHTML = pressReleaseTpl(data)
      } else if (type === 'press-summary') {
        data.desc = truncate(data.desc, 450)
        card.classList.add('card--actu', 'min-h-1/2')
        card.innerHTML = pressSummaryTpl(data)
      } else if (type === 'social-network') {
        card.classList.add('card--social-media', 'min-h-1/2')
        card.innerHTML = socialNetworkTpl(data)
      }

      fragment.appendChild(card)

      wrapper.append(card)
    })

    block.classList.remove('hidden')
  },

  resetDisplay() {
    this.hitsDisplayed = 0
    this.forcedType = ''
    this.blockNews.querySelector('.results__wrapper').innerHTML = ''
    this.blockPages.querySelector('.results__wrapper').innerHTML = ''
    this.blockDocument.querySelector('.results__wrapper').innerHTML = ''
    this.blockReport.querySelector('.results__wrapper').innerHTML = ''
    this.blockPressSummary.querySelector('.results__wrapper').innerHTML = ''
    this.blockPressRelease.querySelector('.results__wrapper').innerHTML = ''
    this.blockEvents.querySelector('.results__wrapper').innerHTML = ''
    this.blockSocialNetworks.querySelector('.results__wrapper').innerHTML = ''
  },

  triggerResizeForHeaderCalculation() {
    var resizeEvent = window.document.createEvent('UIEvents')
    resizeEvent.initUIEvent('resize', true, false, window, 0)
    window.dispatchEvent(resizeEvent)
  },

  componentWillUnmount() {},
}
